import { useEffect, useState } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import { categories } from "../components/Category/category";
import "../style/menuForm.css"
import { sendMenuItem } from '../utils/functionFirebase';
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { doc, getDoc } from "firebase/firestore";
import { data } from "../firebase/firebese";

export default function MenuForm() {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    imgUrl: "",
    newPrice: "",
    oldPrice: "",
    category: "all",
    section: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    if (!auth.currentUser) {
      toast.error("يرجى تسجيل الدخول أولاً!");
      navigate("/auth");
      return;
    }
    
    // تحقق من أن المستخدم أدمن
    const checkAdminStatus = async () => {
      const userDoc = await getDoc(doc(data, "authentact", auth.currentUser.uid));
      if (!userDoc.exists() || userDoc.data().isAdmain !== true) {
        toast.error("ليس لديك صلاحية للوصول لهذه الصفحة!");
        navigate("/");
        return;
      }
    };
    
    checkAdminStatus();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (section) => {
    // تحقق من الحقول الفارغة يدويًا
    if (!formData.title.trim() || !formData.description.trim() || !formData.newPrice.trim() || !formData.category || formData.category === "all") {
      setError("يرجى تعبئة جميع الحقول المطلوبة.");
      setSuccess("");
      return;
    }
    // تحقق أن السعر الجديد رقم موجب
    if (isNaN(Number(formData.newPrice)) || Number(formData.newPrice) <= 0) {
      setError("يرجى إدخال سعر جديد صحيح (رقم موجب).");
      setSuccess("");
      return;
    }
    // تحقق أن السعر القديم إذا وُجد يجب أن يكون رقم موجب
    if (formData.oldPrice && (isNaN(Number(formData.oldPrice)) || Number(formData.oldPrice) <= 0)) {
      setError("إذا أدخلت سعرًا قديمًا يجب أن يكون رقمًا موجبًا.");
      setSuccess("");
      return;
    }
    setError("");
    setSubmitting(true);
    const result = await sendMenuItem({ ...formData, section });
    setSubmitting(false);
    if (result.success) {
      setFormData({
        title: "",
        description: "",
        imgUrl: "",
        newPrice: "",
        oldPrice: "",
        category: "all",
        section: "",
      });
      toast.success("تمت إضافة الصنف بنجاح!");
      setSuccess("");
    } else {
      toast.error("خطأ في الإرسال: " + (result.error || ""));
      setError("");
      setSuccess("");
      console.error("خطأ في الإرسال:", result.error);
    }
  };

  // دالة تتحقق من صحة الحقول المطلوبة
  const isFormValid = formData.title.trim() && formData.description.trim() && formData.newPrice.trim() && !isNaN(Number(formData.newPrice)) && Number(formData.newPrice) > 0 && formData.category && formData.category !== "all" && (formData.oldPrice === "" || (!isNaN(Number(formData.oldPrice)) && Number(formData.oldPrice) > 0));

  return (
    <div className="menuForm">
      {error && (
        <div className="alert alert-danger text-end">{error}</div>
      )}
      {success && (
        <div className="alert alert-success text-end">{success}</div>
      )}


    <Card className="p-4 mt-4 ">
      <h4 className="mb-3 text-end">إضافة صنف جديد</h4>
      <Form onSubmit={e => e.preventDefault()} dir="rtl">
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formTitle">
              <Form.Label>العنوان</Form.Label>
              <Form.Control
                type="text"
                placeholder="مثلاً: بيتزا مارجريتا"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formImage">
              <Form.Label>رابط الصورة</Form.Label>
              <Form.Control
                type="text"
                placeholder="https://image.url"
                name="imgUrl"
                value={formData.imgUrl}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3" controlId="formDesc">
          <Form.Label>الوصف</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="مثلاً: تحتوي على جبنة ومكونات طازجة"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formOldPrice">
              <Form.Label>السعر القديم (اختياري)</Form.Label>
              <Form.Control
                type="number"
                placeholder="مثلاً: 10"
                name="oldPrice"
                value={formData.oldPrice}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formNewPrice">
              <Form.Label>السعر الجديد</Form.Label>
              <Form.Control
                type="number"
                placeholder="مثلاً: 7"
                name="newPrice"
                value={formData.newPrice}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3" controlId="formCategory">
          <Form.Label>التصنيف</Form.Label>
          <Form.Select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="form-select text-end custom-select"
            dir="rtl"
          >
            {categories.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Row className="mb-3">
          <Col>
            <Button
              variant="success"
              className="w-100"
              disabled={submitting || !isFormValid}
              onClick={() => handleSubmit("menu")}
              type="button"
            >
              {submitting ? "...جاري الإضافة" : "إضافة إلى المنيو"}
            </Button>
          </Col>
          <Col>
            <Button
              variant="warning"
              className="w-100"
              disabled={submitting || !isFormValid}
              onClick={() => handleSubmit("offers")}
              type="button"
            >
              {submitting ? "...جاري الإضافة" : "إضافة إلى العروض"}
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
    </div>
  );
}
